import React from 'react';
import { Modal, Button as BootstrapButton } from 'react-bootstrap';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { useModelosListagem, useModeloNavegacao } from '../hooks';
import ModeloHeader from './ModeloHeader';
import ModeloTable from './ModeloTable';
import ModeloFilter from './ModeloFilter';

const ModeloCard = ({
  id,
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  // Hooks
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    showDeleteModal,
    pedidoToDelete,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    confirmDelete,
    cancelDelete,
    setPaginaAtual,
    setQuantidadePorPagina
  } = useModelosListagem(id);
  const {
    handleRowClick,
    handleAdicionar,
    handleEditar
  } = useModeloNavegacao();
  return <>
    <Card>
      <CardBody>
        {showHeader && <ModeloHeader totalRegistros={totalRegistros} onAdicionar={showActions ? handleAdicionar : undefined} />}

        {showFilter && <ModeloFilter loading={filterLoading} onApply={handleFilterApply} onLimpar={handleLimparFiltros} />}

        <ModeloTable data={data} loading={loading} onRowClick={enableRowClick ? handleRowClick : undefined} onEditar={showActions ? handleEditar : undefined} onExcluir={showActions ? handleExcluir : undefined} manualPagination={true} totalRegistros={totalRegistros} controlledPagination={{
          pageIndex: Math.max(0, (paginaAtual || 1) - 1),
          pageSize: quantidadePorPagina || 10
        }} onPaginationChange={next => {
          if (next && typeof next.pageSize === 'number') {
            setQuantidadePorPagina(next.pageSize);
          }

          if (next && typeof next.pageIndex === 'number') {
            setPaginaAtual(next.pageIndex + 1);
          }
        }} />
      </CardBody>
    </Card>

    {
      /* Modal de Confirmação de Exclusão */
    }
    <Modal show={showDeleteModal} onHide={cancelDelete} animation={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Exclusão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Tem certeza que deseja excluir o pedido <strong>{pedidoToDelete?.numeroDoPedido}</strong>?
        </p>
        <p className="text-muted">
          Esta ação não pode ser desfeita.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <BootstrapButton variant="secondary" onClick={cancelDelete}>
          Cancelar
        </BootstrapButton>
        <BootstrapButton variant="danger" onClick={confirmDelete}>
          Excluir
        </BootstrapButton>
      </Modal.Footer>
    </Modal>
  </>;
};

export default ModeloCard;
